import type { ReactNode } from 'react';
import React from 'react';
export interface DebugInfoReadoutItem {
  title: string;
  value: string | number | ReactNode;
}
interface DebugInfoReadoutProps {
  additionalContent?: ReactNode;
  content: DebugInfoReadoutItem[];
  title: string;
}
export const DebugInfoReadout = ({
  title,
  content
}: DebugInfoReadoutProps) => <div className="p-4" data-sentry-component="DebugInfoReadout" data-sentry-source-file="index.tsx">
    <div className="rounded-lg border-2 border-pink-500 border-dashed bg-gray-100 p-6 text-gray-950 dark:bg-gray-900 dark:text-white">
      <div className="font-bold text-lg sm:text-xl">{title}</div>
      <hr className="my-4 opacity-30" />
      <dl className="grid-cols-[auto_1fr] gap-x-4 gap-y-1 sm:grid [&>dt]:font-semibold">
        {content.length > 0 && content.map((contentItem, index) => <React.Fragment key={`${contentItem.title}-${index}`}>
              <dt className="uppercase">{contentItem.title}</dt>
              <dd className="font-mono">{contentItem.value}</dd>
            </React.Fragment>)}
      </dl>
    </div>
  </div>;